import cn from 'classnames'
import React, { FC, useCallback } from 'react'

import { ExpandedRowContent } from './expandedRowContent/ExpandedRowContent'
import { IPartnerDuplicatesRowProps } from './models'

import styles from './PartnerDuplicatesRow.module.scss'

export const PartnerDuplicatesRow: FC<IPartnerDuplicatesRowProps> = ({
  additional,
  contentActions,
  searchResult,
  renderChildren,
  rowAttrs,
  rowState,
  contentMessages,
  tableAdditionalColumns,
  sortDifference,
  changeTabsOpeningState,
  isOpened,
  styleClasses,
}) => {
  const onRowClickHandler = useCallback(() => {
    changeTabsOpeningState(rowAttrs?.key, !isOpened)
  }, [isOpened, rowAttrs?.key, changeTabsOpeningState])

  return (
    <>
      <tr
        {...rowAttrs}
        className={cn(rowAttrs.className, styles.row, { [styles.selected]: isOpened })}
        onClick={onRowClickHandler}
      >
        {renderChildren(searchResult, rowState, additional)}
      </tr>

      {isOpened && (
        <tr className={cn({ [styles.expanded]: isOpened })}>
          <td colSpan={13}>
            <ExpandedRowContent
              contentActions={contentActions}
              searchResult={searchResult}
              contentMessages={contentMessages}
              tableAdditionalColumns={tableAdditionalColumns}
              sortDifference={sortDifference}
              styleClasses={styleClasses}
            />
          </td>
        </tr>
      )}
    </>
  )
}
